import {
  AuthProvider as SharedAuthProvider,
  type AuthProviderProps,
} from "@mattfinkel/common-web";
import { auth } from "../firebase";
import { api } from "../lib/api";

// A binding shim, not a reimplementation. The 5-state machine
// (idle/verifying/allowed/unavailable/denied), its retry/backoff, the
// sticky-denied handling and the in-flight probe cancellation all live in
// @mattfinkel/common-web; every incident comment that earned them is recorded
// there. This file exists only so `main.tsx` and `App.tsx` keep importing from
// "./auth/AuthProvider" with no arguments to pass.
export { useAuth } from "@mattfinkel/common-web";

export function AuthProvider({
  children,
  probeBackoffMs,
}: Pick<AuthProviderProps, "children" | "probeBackoffMs">) {
  return (
    <SharedAuthProvider auth={auth} api={api} probeBackoffMs={probeBackoffMs}>
      {children}
    </SharedAuthProvider>
  );
}
